(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/ticket-skin-sunfeather.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/ticket-skin-sunfeather.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState,
  useMemo = _React.useMemo,
  memo = _React.memo;
const sunfeather = svs.tickets.play.utils.animations.sunfeather;
const TicketSkinImage = svs.tickets.play.components.TicketSkinImage;
function useSunfeatherAnimation(animation) {
  const ref = useRef(null);
  const intro = useMemo(() => (sunfeather.intro[animation] || sunfeather.intro.default).bind(null, ref), [ref, animation]);
  const select = useMemo(() => (sunfeather.select[animation] || sunfeather.select.default).bind(null, ref), [ref, animation]);
  const mouseEnter = useMemo(() => (sunfeather.mouseEnter[animation] || sunfeather.mouseEnter.default).bind(null, ref), [ref, animation]);
  const sibblingEnter = useMemo(() => (sunfeather.sibblingEnter[animation] || sunfeather.sibblingEnter.default).bind(null, ref), [ref, animation]);
  const mouseLeave = useMemo(() => (sunfeather.mouseLeave[animation] || sunfeather.mouseLeave.default).bind(null, ref), [ref, animation]);
  const outro = useMemo(() => (sunfeather.outro[animation] || sunfeather.outro.default).bind(null, ref), [ref, animation]);
  return {
    ref,
    intro,
    select,
    mouseEnter,
    sibblingEnter,
    mouseLeave,
    outro
  };
}
setGlobal('svs.tickets.play.components.TicketSkinSunfeather', memo(_ref => {
  let gamePayed = _ref.gamePayed,
    hasFocus = _ref.hasFocus,
    number = _ref.number,
    handleGamePay = _ref.handleGamePay,
    onHandleNumberChanged = _ref.onHandleNumberChanged,
    _ref$numberOfTickets = _ref.numberOfTickets,
    numberOfTickets = _ref$numberOfTickets === void 0 ? 31 : _ref$numberOfTickets,
    image = _ref.image,
    _ref$appTimeline = _ref.appTimeline,
    appTimeline = _ref$appTimeline === void 0 ? gsap.timeline() : _ref$appTimeline,
    chosen = _ref.chosen,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    hoverState = _ref.hoverState,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loaded = _useState2[0],
    setLoaded = _useState2[1];
  const imgRef = useRef(null);
  const _useSunfeatherAnimati = useSunfeatherAnimation(animation),
    ticketSkinRef = _useSunfeatherAnimati.ref,
    intro = _useSunfeatherAnimati.intro,
    select = _useSunfeatherAnimati.select,
    mouseEnter = _useSunfeatherAnimati.mouseEnter,
    sibblingEnter = _useSunfeatherAnimati.sibblingEnter,
    mouseLeave = _useSunfeatherAnimati.mouseLeave,
    outro = _useSunfeatherAnimati.outro;
  useEffect(() => {
    if (imgRef.current) {
      setLoaded(true);
    }
  }, [imgRef.current]);

  useEffect(() => {
    if (loaded) {
      const tl = gsap.timeline();
      const unmount = intro(tl, number);
      if (chosen) {
        select(tl);
      }
      appTimeline.add(tl, 'gameReady');
      return () => {
        unmount && unmount();
        tl.kill();
      };
    }
  }, [loaded, number]);

  useEffect(() => {
    if (appTimeline.time() > (appTimeline.labels.gameReady || 0)) {
      if (chosen) {
        const tl = select();
        return () => {
          tl && tl.kill(ticketSkinRef.current);
        };
      }
      appTimeline.progress(1, false);
      mouseLeave(number);
    }
  }, [chosen]);

  useEffect(() => {
    if (!chosen && !gamePayed && loaded && appTimeline.time() > (appTimeline.labels.gameReady || 0)) {
      if (hoverState === 0) {
        mouseEnter(number);
      } else if (hoverState) {
        sibblingEnter(hoverState, number);
      } else {
        mouseLeave(number);
      }
    }
  }, [hoverState, loaded, number]);

  useEffect(() => {
    if (gamePayed) {
      outro();
    }
  }, [gamePayed]);
  const onClick = useCallback(() => {
    if (!gamePayed && chosen) {
      handleGamePay && handleGamePay();
    } else {
      onHandleNumberChanged(number);
    }
  }, [gamePayed, chosen, handleGamePay, onHandleNumberChanged, number]);
  const onHoverEnter = useCallback(() => !chosen && onMouseEnter(number), [chosen, onMouseEnter, number]);
  const onHoverLeave = useCallback(() => !chosen && onMouseLeave(number), [chosen, onMouseLeave, number]);
  return React.createElement("div", {
    className: "".concat(loaded ? 'image-loaded' : '', " ticket-skin-wrapper relative"),
    "data-ticket-number": number,
    onClick: onClick,
    ref: ticketSkinRef,
    style: {
      transform: 'scale(0)',
      zIndex: numberOfTickets - number,
      transformOrigin: '50% 100%',
      rotate: '0deg'
    }
  }, React.createElement("div", {
    className: "ticket-number absolute"
  }, number), React.createElement("div", {
    className: "".concat(hasFocus ? 'ticket-skin-focus' : ''),
    onMouseEnter: onHoverEnter,
    onMouseLeave: onHoverLeave,
    ref: imgRef
  }, React.createElement(TicketSkinImage, {
    image: image,
    number: number
  })));
}));

 })(window);